/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
export { ISingletonFactory__factory } from "./ISingletonFactory__factory";
export { WriteOnce__factory } from "./WriteOnce__factory";
